import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "StatusBarReminders" */ "./lazyIndex"), { name: "StatusBarReminders" });

export const LazyStatusBarReminders: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.StatusBarReminders);
